import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=0b036f04&scoped=true&"
import script from "./Uploader.vue?vue&type=script&lang=ts&"
export * from "./Uploader.vue?vue&type=script&lang=ts&"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=0b036f04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b036f04",
  null
  
)

export default component.exports